import script from "./WorkspaceSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceSelector.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceSelector.vue?vue&type=style&index=0&id=75f2c923&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f2c923"]])

export default __exports__